module.exports = __webpack_public_path__ + "img/logo-gf-stiftung-compact.fd9d9b1c.svg";